import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["__mapped"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { pascalCase } from "./lib/pascalCase.js";
var TODOSliceComponent = function TODOSliceComponent(_ref) {
  var slice = _ref.slice;
  if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
    var type = "slice_type" in slice ? slice.slice_type : slice.type;
    console.warn("[SliceZone] Could not find a component for Slice type \"".concat(type, "\""), slice);
    return /* @__PURE__ */jsxs("section", {
      "data-slice-zone-todo-component": "",
      "data-slice-type": type,
      children: ["Could not find a component for Slice type “", type, "”"]
    });
  } else {
    return null;
  }
};
function SliceZone(_ref2) {
  var _ref2$slices = _ref2.slices,
    slices = _ref2$slices === void 0 ? [] : _ref2$slices,
    _ref2$components = _ref2.components,
    components = _ref2$components === void 0 ? {} : _ref2$components,
    resolver = _ref2.resolver,
    _ref2$defaultComponen = _ref2.defaultComponent,
    defaultComponent = _ref2$defaultComponen === void 0 ? TODOSliceComponent : _ref2$defaultComponen,
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? {} : _ref2$context;
  if (process.env.NODE_ENV === "development") {
    if (resolver) {
      console.warn("The `resolver` prop is deprecated. Please replace it with a components map using the `components` prop.");
    }
  }
  var renderedSlices = slices.map(function (slice, index) {
    var type = "slice_type" in slice ? slice.slice_type : slice.type;
    var Comp = components[type] || defaultComponent;
    if (resolver) {
      var resolvedComp = resolver({
        slice: slice,
        sliceName: pascalCase(type),
        i: index
      });
      if (resolvedComp) {
        Comp = resolvedComp;
      }
    }
    var key = "id" in slice && slice.id ? slice.id : "".concat(index, "-").concat(JSON.stringify(slice));
    if (slice.__mapped) {
      var __mapped = slice.__mapped,
        mappedProps = _objectWithoutProperties(slice, _excluded);
      return /* @__PURE__ */jsx(Comp, _objectSpread({}, mappedProps), key);
    } else {
      return /* @__PURE__ */jsx(Comp, {
        slice: slice,
        index: index,
        slices: slices,
        context: context
      }, key);
    }
  });
  return /* @__PURE__ */jsx(Fragment, {
    children: renderedSlices
  });
}
export { SliceZone, TODOSliceComponent };